import { render } from "./viajesComponent.vue?vue&type=template&id=6f514f6f"
import script from "./viajesComponent.vue?vue&type=script&lang=js"
export * from "./viajesComponent.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__